<mat-tab-group class="area-body">
  <mat-tab label="Géométries">
    <app-tab-geometry [form]="form" [isReadOnly]="isReadOnly"></app-tab-geometry>
  </mat-tab>
  <mat-tab label="Attributs et étapes">
    <app-tab-etapes [form]="form" [saving]="saving" [isReadOnly]="isReadOnly"></app-tab-etapes>
  </mat-tab>
</mat-tab-group>

<section class="area-footer" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <button
      *ngIf="!isReadOnly"
      mat-raised-button
      color="primary"
      [disabled]="form?.invalid || form?.pristine || saving"
      (click)="saveChanges()"
    >
      Enregistrer
    </button>
    <mat-spinner style="margin-left: 10px" color="primary" [diameter]="20" *ngIf="saving"></mat-spinner>
  </div>
  <button mat-raised-button color="accent" [disabled]="saving" (click)="cancelChanges()">Annuler</button>
</section>
